import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  PHARMACY_QUEUE_KIOSK_QUESTIONNAIRE_PATH,
  PHARMACY_QUEUE_PATH,
  PHARMACY_QUEUE_QUEUE_JOURNEY_PATH,
  PHARMACY_QUEUE_SELECT_PHARMACY_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const SelectInstitutionPage = lazy(() => import('./pages/SelectInstitutionPage/SelectInstitutionPage'));
const SelectPharmacyPage = lazy(() => import('./pages/SelectPharmacyPage/SelectPharmacyPage'));
const KioskQuestionnairePage = lazy(() => import('./pages/KioskQuestionnairePage/KioskQuestionnairePage'));
const QueueJourneyPage = lazy(() => import('./pages/QueueJourneyPage/QueueJourneyPage'));

export const PHARMACY_QUEUE_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SelectInstitutionPage />,
    displayTitle: () => 'Pharmacy Queue',
    pageType: PageType.PRIVATE,
    path: PHARMACY_QUEUE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.pharmacyQueue,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SelectPharmacyPage />,
    displayTitle: () => 'Pharmacy Queue',
    pageType: PageType.PRIVATE,
    path: PHARMACY_QUEUE_SELECT_PHARMACY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.pharmacyQueue,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <KioskQuestionnairePage />,
    displayTitle: () => 'Pharmacy Questionnaire',
    pageType: PageType.PRIVATE,
    path: PHARMACY_QUEUE_KIOSK_QUESTIONNAIRE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.pharmacyQueue,
  },
  {
    backUrl: PHARMACY_QUEUE_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <QueueJourneyPage />,
    displayTitle: () => 'Queue Status',
    pageType: PageType.PRIVATE,
    path: PHARMACY_QUEUE_QUEUE_JOURNEY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.pharmacyQueue,
  },
];
